var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    { staticClass: "logo-container", attrs: { to: "/" } },
    [
      _c("img", {
        staticClass: "logo",
        attrs: {
          src: "/dist/logos/website/footer-logo.svg",
          title: `${_vm.siteName} Logo`,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }